import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UserFormStateService } from '../../users/Service/formStateService';
import { UserService } from '../../../Service/User/user.service';
import { ServiceAdvisorFormStateService } from '../service/service-advisor-formStateService';
import { ServiceAdvisorResumeComponent } from './service-advisor-resume/service-advisor-resume.component';
import { ServiceAdvisorCertificatesComponent } from './service-advisor-certificates/service-advisor-certificates.component';
import { AddServiceAdvisorDetailsComponent } from './add-service-advisor-details/add-service-advisor-details.component';
import { AddressproofComponent } from '../../../location/addressproof/addressproof.component';
import { MapLocationComponent } from '../../../location/map-location/map-location.component';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-add-service-advisor',
  templateUrl: './add-service-advisor.component.html',
  styleUrl: './add-service-advisor.component.scss',
})
export class AddServiceAdvisorComponent {
  @Input() id?: number;
  @Output() updateUserList = new EventEmitter<void>();
  @Output() closeDialog = new EventEmitter<void>();

  @ViewChild(MapLocationComponent)
  mapLocation!: MapLocationComponent;

  @ViewChild(AddressproofComponent)
  addressProof!: AddressproofComponent;

  @ViewChild(AddServiceAdvisorDetailsComponent) serviceAdvisorDetails!: AddServiceAdvisorDetailsComponent;
  @ViewChild(ServiceAdvisorResumeComponent) serviceAdvisorResume!: ServiceAdvisorResumeComponent;
  @ViewChild(ServiceAdvisorCertificatesComponent) serviceAdvisorCertificates!: ServiceAdvisorCertificatesComponent;

  editMode: boolean = false;
  activeSection: string = 'map-location';
  countryId!: any;
  isServiceAdvisorDetailsValid: boolean = false;
  isResumeValid: boolean = false;

  sectionValidity: { [key: string]: boolean } = {
    'service-advisor-details': false,
    resume: false,
    'service-advisor-certificates': false,
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private api: UserService,
    public serviceAdvisorformStateService: ServiceAdvisorFormStateService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    const finalId = this.route.snapshot.paramMap.get('serviceAdvisorId')
    this.id = +finalId!
    console.log('Recieved Id from route:', this.id)
    this.editMode = !!this.id;
    if (this.editMode) {
      this.serviceAdvisorById(<number>this.id);
    }
    if (!this.editMode) {
      this.serviceAdvisorformStateService.clearFormData()
    }
    // this.setActiveSection(this.activeSection)
  }

  initializeForm(): void {
    const tokenDetailsString = localStorage.getItem('tokenDetails');
    if (tokenDetailsString) {
      const tokenDetails = JSON.parse(tokenDetailsString);
      this.countryId = tokenDetails.country?.countryId;
    }
  }

  serviceAdvisorById(id: number): void {
    this.api.getServiceAdvisorById(id).subscribe((res: any) => {
      // Store the retrieved object in form state
      this.serviceAdvisorformStateService.updateObject(res);

      const uploadedFileId = this.serviceAdvisorformStateService.getUploadedFileId('resumeFile');
      const resumeDocument = res.serviceAdvisorDocuments?.find(
        (doc: any) => doc.documentTypeId === 12
      );

      if (!uploadedFileId && resumeDocument) {
        this.serviceAdvisorformStateService.setFormData('resumeFile', {
          fileName: resumeDocument.fileName,
          fileUrl: resumeDocument.filePath,
          file: resumeDocument.fileId,
        }
        );
      }
      if (this.mapLocation) {
        this.mapLocation.populateLocationFromBackend(res)
      }
      if (this.addressProof) {
        this.addressProof.populateAddressProofFromResponse(res)
      }
      if (this.serviceAdvisorDetails) {
        console.log('Populating Service Advisor Details');
        this.serviceAdvisorDetails.populateFormWithServiceProviderDetails(res);
      }
      if (this.serviceAdvisorResume) {
        this.serviceAdvisorResume.populateFormWithServiceProviderDetails(res);
        console.log('Done')
      }

      // Certificates section: only set data if the file IDs are not already uploaded
      const identityCardFileId = this.serviceAdvisorformStateService.getUploadedFileId('identityCard');
      const qualificationCertificatesFileId = this.serviceAdvisorformStateService.getUploadedFileId('qualificationCertificates');
      const experienceCertificatesFileId = this.serviceAdvisorformStateService.getUploadedFileId('experienceCertificates');
      const otherCertificatesFileId = this.serviceAdvisorformStateService.getUploadedFileId('otherCertificates');

      // Extract file data for certificates
      const identityCard = res.serviceAdvisorDocuments?.find((doc: any) => doc.documentTypeId === 7);
      const qualificationCertificates = res.serviceAdvisorDocuments?.find((doc: any) => doc.documentTypeId === 13);
      const experienceCertificates = res.serviceAdvisorDocuments?.find((doc: any) => doc.documentTypeId === 14);
      const otherCertificates = res.serviceAdvisorDocuments?.find((doc: any) => doc.documentTypeId === 15);

      // Setting the certificate data in the formStateService if not already uploaded
      if (!identityCardFileId && identityCard) {
        this.serviceAdvisorformStateService.setFormData('identityCard', {
          fileName: identityCard.fileName,
          fileUrl: identityCard.filePath,
          file: identityCard.fileId,
        });
      }

      if (!qualificationCertificatesFileId && qualificationCertificates) {
        this.serviceAdvisorformStateService.setFormData('qualificationCertificates', {
          fileName: qualificationCertificates.fileName,
          fileUrl: qualificationCertificates.filePath,
          file: qualificationCertificates.fileId,
        });
      }

      if (!experienceCertificatesFileId && experienceCertificates) {
        this.serviceAdvisorformStateService.setFormData('experienceCertificates', {
          fileName: experienceCertificates.fileName,
          fileUrl: experienceCertificates.filePath,
          file: experienceCertificates.fileId,
        });
      }

      if (!otherCertificatesFileId && otherCertificates) {
        this.serviceAdvisorformStateService.setFormData('otherCertificates', {
          fileName: otherCertificates.fileName,
          fileUrl: otherCertificates.filePath,
          file: otherCertificates.fileId,
        });
      }

      // Patch into the certificates component if/when loaded
      if (this.serviceAdvisorCertificates && this.editMode && this.id) {
        console.log('Populating Service Advisor Certificates');
        this.serviceAdvisorCertificates.populateFormWithServiceProviderDetails(res);
        this.cdr.detectChanges();
      }
    });
  }

  setActiveSection(section: string): void {
    this.activeSection = section;
    this.cdr.detectChanges();
    console.log(this.editMode)

    if (section === 'map-location' && this.editMode && this.id) {
      console.log('Editmode when map-location is called:', this.editMode)
      this.serviceAdvisorById(this.id)
    }
    if (section === 'address-proof' && this.editMode && this.id) {
      console.log('Edit mode when address-proof is called', this.editMode)
      this.serviceAdvisorById(this.id)
    }
    if (section === 'service-advisor-details' && this.editMode && this.id) {
      this.serviceAdvisorById(this.id)
    }
    if (section === 'resume' && this.editMode && this.id) {
      this.serviceAdvisorById(this.id);
    }
    if (section === 'service-advisor-certificates' && this.editMode && this.id) {
      this.serviceAdvisorById(this.id);
    }
  }

  close(): void {
    if (this.serviceAdvisorDetails) {
      this.serviceAdvisorDetails.resetForm();
      this.cdr.detectChanges();
    }

    if (this.serviceAdvisorResume) {
      this.serviceAdvisorResume.resetForm();
      this.cdr.detectChanges();
    }

    if (this.serviceAdvisorCertificates) {
      this.serviceAdvisorCertificates.resetForm();
      this.cdr.detectChanges();
    }
    this.serviceAdvisorformStateService.clearFormData();
    this.closeDialog.emit();
    this.location.back()
  }

  onUpdateUserList(): void {
    this.updateUserList.emit();
  }
}
